import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appOnlyNumbers]',
  standalone:false
})
export class OnlyNumbersDirective {

  @HostListener('keypress', ['$event'])
  onKeyPress(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab'];
    if (allowedKeys.indexOf(event.key) !== -1) {
      return; // Allow navigation keys
    }
    const regex = /[0-9]/;
    if (!regex.test(event.key)) {
      event.preventDefault(); // Prevent non-numeric input
    }
  }

}
